import ValidService from '../../../service/ValidService';
let model = {};

// dữ liệu form
model.dataForm = {
    "year": undefined, // required Năm
    "name": undefined, // required Tên ngày nghỉ
    "off_date": undefined, // required Ngày nghỉ lễ
    "disabled": undefined, // required Đã bị khóa chưa
};

// validation form
model.validForm = {
    "year": [ValidService.requiredChange], // required Năm
    "name": [
                ValidService.required,
                ValidService.checkSpaceString,
                {
                    pattern: /^[^!@#$%^&*()_+\=\[\]{};':"\\|,.<>\?]+$/g,
                    message: "Không nhập ký tự đặc biệt",
                    trigger: "blur"
                }
            ], // required Tên ngày nghỉ
    "off_date": [ValidService.requiredChange], // required Ngày nghỉ lễ
};

// dữ liệu mẫu các form khác
model.dataFormOther = {

};

// validation các form khác
model.validFormOther = {};


model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["", "ascending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            "year": "",
            "name": "",
            "off_date": "",
            "disabled": "",
        },
        valid: {
            "year": [],
            "name": [],
            "off_date": [],
            "disabled": [],
        },
        operator: {
            "year": "",
            "name": "$vn_text=",
            "off_date": ":in_that_day:",
            "disabled": "",
        }
    }
};

export default model;
